import { createFileRoute, redirect } from '@tanstack/react-router';

/** Jobs went with roles (web-redesign-03 phase 2.5): an old link opens Roles. */
export const Route = createFileRoute('/_app/business/jobs/')({
  beforeLoad: () => {
    throw redirect({ to: '/business/roles', replace: true });
  },
});
